import {
  SHOW_GETTING_STARTED_DIALOG,
  SHOW_SUPPORT_DIALOG,
  SHOW_PRIVACY_POLICY_DIALOG
} from "./dialogsActions";

const initialState = {
  openGettingStartedDialog: false,
  openSupportDialog: false,
  openPrivacyPolicyDialog: false
};

const dialogsReducer = (state = initialState, action ) => {
  switch (action.type) {
    case SHOW_GETTING_STARTED_DIALOG:
      return {
        openSupportDialog: false,
        openPrivacyPolicyDialog: false,
        openGettingStartedDialog: action.payload
      };
    case SHOW_SUPPORT_DIALOG:
      return {
        openGettingStartedDialog: false,
        openPrivacyPolicyDialog: false,
        openSupportDialog: action.payload
      };
    case SHOW_PRIVACY_POLICY_DIALOG:
      return {
        openGettingStartedDialog: false,
        openSupportDialog: false,
        openPrivacyPolicyDialog: action.payload
      };
    default:
      return { ...state };
  }
};

export default dialogsReducer;
